export default __webpack_public_path__ + "static/media/haux.0d443d51.svg";